import { render, staticRenderFns } from "./UpdateAttribute.vue?vue&type=template&id=1ce86c92&"
import script from "./UpdateAttribute.vue?vue&type=script&lang=js&"
export * from "./UpdateAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports